jQuery(function(){

      var policyButton = jQuery('#policy-select--submit');
      var claimButton = jQuery('#claim-select--submit');
    var buttons = [ policyButton, claimButton ];

    jQuery.each(buttons, function(i, button){

        if (button.length > 0) {
            button.on('click', function(event) {
                event.preventDefault();
                var form = button.parents('form');
                var select = form.find('select');

                if (select.val()) {
                    window.location.href = select.val();
                } else {

                    var $container = form.find('.input__select-container');
                    $container.addClass('input__select-container--error');

                    return false;
                }

            });
        }
    });
});
